export const AppSubscriptions = {
    MANUAL: "Manual",
    AUTOMATIC: "Automatic"
  };
  
  export default AppSubscriptions;
  